import "./TD1AdminFormStyle.css";

import { AppBar, Grid, Toolbar } from "@mui/material";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedSnackbar,
	IResponse,
	IServerError,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_STATUS_SETUP_SCREEN_SLUG,
	INITIAL_SNACKBAR_DATA,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { base64ToPdfFile, formatDate, scrollPanelFieldsToTop, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { CountryService } from "../../services/common/CountryService";
import { IAppState } from "../../store/reducers";
import { ProvinceService } from "../../services/common/ProvinceService";
import { TD1AdminFormDataTable } from "./Panels/TD1AdminFormDataTable/TD1AdminFormDataTable";
import { TD1AdminFormDataTableWithFixedRows } from "./Panels/TD1AdminFormDataTableWithFixedRows/TD1AdminFormDataTableWithFixedRows";
import { TD1AdminFormHeader } from "./TD1AdminFormHeader";
import { TD1AdminFormValidationSchema } from "./validator";
import { TD1FormServices } from "../../services/TD1FormServices";
import TD1PdfFileAdminForm from "./Panels/TD1PdfFileAdminForm";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { ProvinceService } from "../../services/ProvinceService";






export interface ITD1AdminForm { }
const SINGLE_RECORD_DATA_QUERY_KEY = "employee-single-data-record";

const useGetData = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
		queryFn: () => {
			return TD1FormServices.getTD1AdminFormData(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: () => CountryService.getCountryDDL(),
		refetchOnWindowFocus: false,
	});

export let td1AdminFormInitialData = [
	{
		id: "1",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "2",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "3",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "4",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "5",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "6",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "7",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "8",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "9",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "10",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "11",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "12",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "13",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "14",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
	{
		id: "15",
		heading: null,
		detail: null,
		value: null,
		xCordinates: null,
		yCordinates: null,
	},
];

// export let td1AdminFormInitialDataWithFixedRows = [
// 	{
// 		id: "1",
// 		heading: "Enter the x/y Cordinates of Last Name",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "2",
// 		heading: "Enter the x/y Cordinates of First Name",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "3",
// 		heading: "Enter the x/y Cordinates of Date of Birth",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "4",
// 		heading: "Enter the x/y Cordinates of Employee No",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "5",
// 		heading: "Enter the x/y Cordinates of Address with postcode",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "6",
// 		heading: "Enter the x/y Cordinates of Social Insurance no",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "7",
// 		heading:
// 			"Enter the x/y Cordinates of Deduction for living in a prescribed zone",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// 	{
// 		id: "8",
// 		heading: "Enter the x/y Cordinates of Additional tax to be deducted",
// 		xCordinate: null,
// 		yCordinate: null,
// 	},
// ];

export const TD1AdminFormheaderColumns = [
	{
		field: `heading`,
		headerName: `Heading`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		minWidth: 250,
		maxWidth: 250,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "detail",
		headerName: "Details",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 2,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "value",
		headerName: "Value",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		minWidth: "12rem",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "xCordinates",
		headerName: "X-Cordinate",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		minWidth: "12rem",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 4,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "yCordinates",
		headerName: "Y-Cordinate",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		minWidth: "12rem",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 5,
		frozenColumn: false,
		footer: null,
	},
];

// export const TD1AdminFormheaderColumnsWithFixedRows = [
// 	{
// 		field: `heading`,
// 		headerName: `Heading`,
// 		description: "",
// 		flex: 1,
// 		hide: false,
// 		hideable: false,
// 		sortable: true,
// 		sortingOrder: "asc",
// 		resizable: false,
// 		type: "string",
// 		align: "left",
// 		headerAlign: "center",
// 		hideSortIcons: false,
// 		disableColumnMenu: true,
// 		disableReorder: true,
// 		disableExport: true,
// 		maskable: false,
// 		isFixed: true,
// 		sequence: 0,
// 		frozenColumn: false,
// 		footer: null,
// 	},
// 	{
// 		field: "xCordinate",
// 		headerName: "X-Cordinate",
// 		description: "",
// 		flex: 1,
// 		hide: false,
// 		hideable: false,
// 		sortable: true,
// 		sortingOrder: "asc",
// 		resizable: false,
// 		type: "string",
// 		align: "left",
// 		headerAlign: "center",
// 		minWidth: "12rem",
// 		hideSortIcons: false,
// 		disableColumnMenu: true,
// 		disableReorder: true,
// 		disableExport: true,
// 		maskable: false,
// 		isFixed: true,
// 		sequence: 1,
// 		frozenColumn: false,
// 		footer: null,
// 	},
// 	{
// 		field: "yCordinate",
// 		headerName: "Y-Cordinate",
// 		description: "",
// 		flex: 1,
// 		hide: false,
// 		hideable: false,
// 		sortable: true,
// 		sortingOrder: "asc",
// 		resizable: false,
// 		type: "string",
// 		align: "left",
// 		headerAlign: "center",
// 		minWidth: "12rem",
// 		hideSortIcons: false,
// 		disableColumnMenu: true,
// 		disableReorder: true,
// 		disableExport: true,
// 		maskable: false,
// 		isFixed: true,
// 		sequence: 2,
// 		frozenColumn: false,
// 		footer: null,
// 	},
// ];

export const TD1AdminForm: React.FC<ITD1AdminForm> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const [openDialog, setDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [itemSearch, setItemSearch] = useState("");
	const [isLoadingData, setIsLoadingData] = useState(false);
	const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
	const [selectedProvince, setSelectedProvince] = useState<any>(undefined);
	const [selectedDate, setSelectedDate] = useState<any>(undefined);
	// const [td1AdminFormsList, setTD1AdminFormsList] =
	// 	useState<any>(undefined);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	// const clientId = useSelector((state: IAppState) => state.client.id);
	const [td1AdminFormId, setTD1AdminFormId] = useState<number>(0);
	const [provinceDDLItems, setProvinceDDLItems] = useState([]);
	const [pdfFileName, setPdfFileName] = useState<string>("");
	const [pdfSavedFile, setSavedFile] = useState<boolean>(false);
	const [pdfSavedFileUrl, setSavedFileUrl] = useState<any>(undefined);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const navigateToLogout = useNavigateToLogout();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	// const [onDataSubmit, setOnDataSubmit] = useState<any>(undefined);
	const [td1AdminFormData, setTD1AdminFormData] = useState(
		td1AdminFormInitialData
	);
	// const [td1AdminFormDataWithFixedRows, setTD1AdminFormDataWithFixedRows] =
	// 	useState(td1AdminFormInitialDataWithFixedRows);

	const [editableValueChecked, editableSetValueChecked] = useState<boolean>(false);

	const { isPending: isSubmitting, mutate: submitTD1AdminFormFormFields } =
		useMutation({
			mutationFn: TD1FormServices.createTD1AdminForm,
			onSuccess: (res: ITD1AdminForm | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIEmployeeResponse(res)) {
					queryClient.invalidateQueries({
						queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					scrollPanelFieldsToTop();
					let path = `/forms/admin/td1/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
				} else if (res.status === 201) {
					// if (instanceOfIEmployeeResponse(res)) {
					setEditRecordId(res.data.id);
					queryClient.invalidateQueries({
						queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					scrollPanelFieldsToTop();
					let path = `/forms/admin/td1/${res.data.id}`;
					navigate(path);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const formMethods = useForm<any>({
		resolver: yupResolver(TD1AdminFormValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const { data: selectedDataRecord } = useGetData(
		editRecordId,
		navigateToLogout
	);

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	// const { data: provinceDDL } = useGetTD1AdminFormDDL(clientId);
	// const { data: provinceDDL } = 
	// ();

	// useEffect(() => {
	// 	if (Array.isArray(provinceDDL)) {
	// 		setTD1AdminFormsList(sortData(provinceDDL));
	// 	}
	// }, [provinceDDL]);

	// useEffect(() => {
	// 	if (onDataSubmit) {
	// 		createTD1AdminForm(onDataSubmit);
	// 	}
	// }, [onDataSubmit]);
	const convertFileToBase64 = (file: File): Promise<string> => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (error) => reject(error);
		});
	};
	const onSubmit = async (values: any) => {

		const formattedTD1AdminFormDataa = td1AdminFormData.map(
			(item: any, index: number) => ({
				...item,
				indexForValue: index + 1, // start from 1
			})
		);





		const formattedTD1AdminFormData = td1AdminFormData
			.map((item, index) => ({ ...item, indexForValue: index + 1 }))
			.filter(item => Object.entries(item).some(([k, v]) => k !== "indexForValue" && k !== "id" && v !== null && v !== ""));




		const selectedProvince: any = provinceDDLItems.find(
			(value: any) => value.value === values.province
		);
		let payload: any = {
			navigateToLogout: navigateToLogout,
			id: selectedDataRecord && selectedDataRecord.effectiveDate === formatDate(values.effectiveDate) && id ? id : undefined,
			province: values.province === "federal" ? {
				id: "federal",
				name: "Federal",
				shortCode: "FD",
			} : {
				id: selectedProvince.value,
				name: selectedProvince.label,
				shortCode: selectedProvince.shortCode,
			},
			effectiveDate: formatDate(values.effectiveDate),
			td1FormDetail: formattedTD1AdminFormData,
			lastNameX: values.lastNameX,
			lastNameY: values.lastNameY,
			firstNameX: values.firstNameX,
			firstNameY: values.firstNameY,
			dateOfBirthX: values.dateOfBirthX,
			dateOfBirthY: values.dateOfBirthY,
			employeeNumberX: values.employeeNumberX,
			employeeNumberY: values.employeeNumberY,
			addressWithPostCodeX: values.addressWithPostCodeX,
			addressWithPostCodeY: values.addressWithPostCodeY,
			postCodeX: values.postCodeX,
			postCodeY: values.postCodeY,
			socialInsuranceNumberX: values.socialInsuranceNumberX,
			socialInsuranceNumberY: values.socialInsuranceNumberY,
			deductionForLivingInAPrescribedZoneX:
				values.deductionForLivingInAPrescribedZoneX,
			deductionForLivingInAPrescribedZoneY:
				values.deductionForLivingInAPrescribedZoneY,
			additionalTaxToBeDeductedX: values.additionalTaxToBeDeductedX,
			additionalTaxToBeDeductedY: values.additionalTaxToBeDeductedY,
			editable: editableValueChecked,
		};
		if (values.pdfFile && values.pdfFile.length > 0) {

			const file = values.pdfFile[0]
			const base64 = await convertFileToBase64(file);
			const cleanBase64 = base64.split(",")[1];
			payload.pdfFile = cleanBase64;
		} else if (values.pdfFile && pdfSavedFile) {
			const file = values.pdfFile;
			const base64 = await convertFileToBase64(file);
			const cleanBase64 = base64.split(",")[1];
			payload.pdfFile = cleanBase64;
		}

		// alert(JSON.stringify(payload, null, 2));
		submitTD1AdminFormFormFields(payload);

	};

	const onOpenFileClicked = () => {
		if (pdfSavedFileUrl) {
			window.open(pdfSavedFileUrl, "_blank");
		}
	};

	const onCheckRecordClickedHandler = async () => {
		if (!selectedProvince) {
			setSnackbarData({
				open: true,
				message: "Please Select Province!",
				severity: "error",
			});
		} else if (!selectedDate) {
			setSnackbarData({
				open: true,
				message: "Please Select Effective Date!",
				severity: "error",
			});
		} else {
			// const vau= formMethods.watch("effectiveDate");


			(async () => {
				try {
					setIsLoadingData(true);
					const responce = await TD1FormServices.getDataByProvinceAndDate(
						navigateToLogout,
						selectedProvince.id,
						selectedDate
					);

					if (responce && !responce.message) {
						if (responce.pdfFile !== null) {
							const pdfFile = base64ToPdfFile(responce.pdfFile, "td1.pdf");
							formMethods.setValue("pdfFile", pdfFile);
							setPdfFileName(pdfFile.name);
							setSavedFile(true);
							const url = URL.createObjectURL(pdfFile);
							setSavedFileUrl(url);
						}
						else {
							setPdfFileName("");
							setSavedFile(false);

							setSavedFileUrl(undefined);
						}
					}
					// setTD1AdminFormData(responce.);
					// formMethods.setValue('lastNameX',responce.lastNameX)
					if (responce && responce.id) {
						let path = `/forms/admin/td1/${responce.id}`;
						navigate(path);
						setEditRecordId(responce.id);
					} else if (responce && responce.message) {
						setSnackbarData({
							open: true,
							message: responce.message,
							severity: "error"
						})
						let path = `/forms/admin/td1`;
						navigate(path);
						setEditRecordId(undefined);
						setSavedFile(false);
						// formMethods.reset();
					}


				} catch (err: any) {
					alert(err.message)
				} finally {
					setIsLoadingData(false);
				}
			})();
		}
	};


	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === 'province') {
					formMethods.setValue(fieldName, fieldValue.id ?? undefined);
					setSelectedProvince(fieldValue)
				}
				if (fieldName === 'effectiveDate') {
					let date = new Date(fieldValue)
					formMethods.setValue(fieldName, date ?? undefined);
					setSelectedDate(formatDate(date));
				}
				if (selectedDataRecord.pdfFile && selectedDataRecord.pdfFile !== null) {
					const pdfFile = base64ToPdfFile(selectedDataRecord.pdfFile, "td1.pdf");
					formMethods.setValue("pdfFile", pdfFile);
					setPdfFileName(pdfFile.name);
					setSavedFile(true);
					const url = URL.createObjectURL(pdfFile);
					setSavedFileUrl(url);
				}
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteEmployeeById } = useMutation({
		mutationFn: TD1FormServices.deleteTD1AdminFormById,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (
				res === "TD1 Form has been deleted successfully"
			) {
				// remove the cache of the Employee fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				formMethods.reset();
				scrollPanelFieldsToTop();
				let path = `/forms/admin/td1`;
				navigate(path);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteTD1AdminForm = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let Payload = {
				td1AdminFormId: td1AdminFormId,
				navigateToLogout: navigateToLogout,
			};
			deleteEmployeeById(Payload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setTD1AdminFormId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		scrollPanelFieldsToTop();
		// let path = `/accountants/setup`;
		// navigate(path);
	};

	const onProvinceSelectionChangeHandler = (params: any) => {
		if (params.value === "federal") {
			setSelectedProvince({
				id: "federal",
				name: "Federal",
				shortCode: "FD",
			});
		} else {
			setSelectedProvince({
				id: params.value,
				name: params.label,
				shortCode: params.shortCode,
			});
		}

	};
	const onDateSelectionChangeHandler = (params: any) => {

		setSelectedDate(formatDate(params.target.value));

		// setSelectedDate("2025-05-21");
	};


	const expandedLabels = ["Misc."];
	const expandedTD1AdminFormItem = "TD1"; // Special case for "" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (parentLabel === "Misc." && item.label === expandedTD1AdminFormItem) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedTD1AdminFormItem && "/forms/admin/td1",
			};
			return enhancedItem;
		});
	};

	const changeEditableCheckBoxValue = (checked: boolean) => {
		console.log(checked);
		editableSetValueChecked(checked);
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_STATUS_SETUP_SCREEN_SLUG,
				accountantName: "",
				activityType:
					"activity_type=create&activity_type=updated&activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);



	return (
		<Grid
		//  sx={{ pb: "5rem", "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					// isPendingById ||
					isLoadingData ||
					isDeleting
				}
				testId="comapny Setup"
			/>

			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteTD1AdminForm}
				cancelActionHandler={onCloseHandler}
				testId="tax-profile-tab-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<TD1AdminFormHeader
						formMethods={formMethods}
						countryList={countryList ?? []}
						provinceDDLItems={(items: any) => setProvinceDDLItems(items)}
						onProvinceSelectionChangeHandler={onProvinceSelectionChangeHandler}
						onDateSelectionChangeHandler={onDateSelectionChangeHandler}
						onCheckRecordClickedHandler={onCheckRecordClickedHandler}
					/>
					<TD1AdminFormDataTableWithFixedRows
					// td1AdminFormDataWithFixedRows={(data: any) =>
					// 	setTD1AdminFormDataWithFixedRows(data)
					// }
					/>
					<TD1PdfFileAdminForm
						formMethods={formMethods}
						pdfFileName={pdfFileName}
						pdfSavedFile={pdfSavedFile}
						onOpenFileClicked={onOpenFileClicked}
					/>
					<TD1AdminFormDataTable
						td1AdminFormData={(data: any) => setTD1AdminFormData(data)}
						td1AdminFormDataById={selectedDataRecord && selectedDataRecord.td1FormDetail}
						editableValueChecked={editableValueChecked}
						changeEditableCheckBoxValue={changeEditableCheckBoxValue}

					// onDataSubmit={(value: any) => setOnDataSubmit(value)}
					// handleFormDelete={onDeleteClicked}
					/>

					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						data-testId={"testId"}
						sx={{
							backgroundColor: "#fff",
							marginTop: 3,
							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					>
						<Toolbar>
							<EnhancedButtonPrimeReact
								label="Submit"
								type="submit"
								// onClickHandler={handleFormSubmit}
								// icon="pi pi-check"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
							<EnhancedButtonPrimeReact
								// icon="pi pi-trash"
								label="Delete"
								raised
								onClickHandler={onDeleteClicked}
								style={{ marginLeft: "1rem" }}
								severity={EnhancedButtonPrimeReactSeverity.Danger}
							/>
						</Toolbar>
					</AppBar>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
